/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedWeeklyRouteImport } from './routes/_authenticated/weekly'
import { Route as AuthenticatedStoresRouteImport } from './routes/_authenticated/stores'
import { Route as AuthenticatedSettingsRouteImport } from './routes/_authenticated/settings'
import { Route as AuthenticatedPerformanceRouteImport } from './routes/_authenticated/performance'
import { Route as AuthenticatedPayrollRouteImport } from './routes/_authenticated/payroll'
import { Route as AuthenticatedMonthlyRouteImport } from './routes/_authenticated/monthly'
import { Route as AuthenticatedExceptionsRouteImport } from './routes/_authenticated/exceptions'
import { Route as AuthenticatedEmployeesRouteImport } from './routes/_authenticated/employees'
import { Route as AuthenticatedDashboardRouteImport } from './routes/_authenticated/dashboard'
import { Route as AuthenticatedAutoReportingRouteImport } from './routes/_authenticated/auto-reporting'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedWeeklyRoute = AuthenticatedWeeklyRouteImport.update({
  id: '/weekly',
  path: '/weekly',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedStoresRoute = AuthenticatedStoresRouteImport.update({
  id: '/stores',
  path: '/stores',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedSettingsRoute = AuthenticatedSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedPerformanceRoute =
  AuthenticatedPerformanceRouteImport.update({
    id: '/performance',
    path: '/performance',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPayrollRoute = AuthenticatedPayrollRouteImport.update({
  id: '/payroll',
  path: '/payroll',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedMonthlyRoute = AuthenticatedMonthlyRouteImport.update({
  id: '/monthly',
  path: '/monthly',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedExceptionsRoute = AuthenticatedExceptionsRouteImport.update({
  id: '/exceptions',
  path: '/exceptions',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedEmployeesRoute = AuthenticatedEmployeesRouteImport.update({
  id: '/employees',
  path: '/employees',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedDashboardRoute = AuthenticatedDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedAutoReportingRoute =
  AuthenticatedAutoReportingRouteImport.update({
    id: '/auto-reporting',
    path: '/auto-reporting',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/auto-reporting': typeof AuthenticatedAutoReportingRoute
  '/dashboard': typeof AuthenticatedDashboardRoute
  '/employees': typeof AuthenticatedEmployeesRoute
  '/exceptions': typeof AuthenticatedExceptionsRoute
  '/monthly': typeof AuthenticatedMonthlyRoute
  '/payroll': typeof AuthenticatedPayrollRoute
  '/performance': typeof AuthenticatedPerformanceRoute
  '/settings': typeof AuthenticatedSettingsRoute
  '/stores': typeof AuthenticatedStoresRoute
  '/weekly': typeof AuthenticatedWeeklyRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/auto-reporting': typeof AuthenticatedAutoReportingRoute
  '/dashboard': typeof AuthenticatedDashboardRoute
  '/employees': typeof AuthenticatedEmployeesRoute
  '/exceptions': typeof AuthenticatedExceptionsRoute
  '/monthly': typeof AuthenticatedMonthlyRoute
  '/payroll': typeof AuthenticatedPayrollRoute
  '/performance': typeof AuthenticatedPerformanceRoute
  '/settings': typeof AuthenticatedSettingsRoute
  '/stores': typeof AuthenticatedStoresRoute
  '/weekly': typeof AuthenticatedWeeklyRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/login': typeof LoginRoute
  '/_authenticated/auto-reporting': typeof AuthenticatedAutoReportingRoute
  '/_authenticated/dashboard': typeof AuthenticatedDashboardRoute
  '/_authenticated/employees': typeof AuthenticatedEmployeesRoute
  '/_authenticated/exceptions': typeof AuthenticatedExceptionsRoute
  '/_authenticated/monthly': typeof AuthenticatedMonthlyRoute
  '/_authenticated/payroll': typeof AuthenticatedPayrollRoute
  '/_authenticated/performance': typeof AuthenticatedPerformanceRoute
  '/_authenticated/settings': typeof AuthenticatedSettingsRoute
  '/_authenticated/stores': typeof AuthenticatedStoresRoute
  '/_authenticated/weekly': typeof AuthenticatedWeeklyRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/auto-reporting'
    | '/dashboard'
    | '/employees'
    | '/exceptions'
    | '/monthly'
    | '/payroll'
    | '/performance'
    | '/settings'
    | '/stores'
    | '/weekly'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/auto-reporting'
    | '/dashboard'
    | '/employees'
    | '/exceptions'
    | '/monthly'
    | '/payroll'
    | '/performance'
    | '/settings'
    | '/stores'
    | '/weekly'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/login'
    | '/_authenticated/auto-reporting'
    | '/_authenticated/dashboard'
    | '/_authenticated/employees'
    | '/_authenticated/exceptions'
    | '/_authenticated/monthly'
    | '/_authenticated/payroll'
    | '/_authenticated/performance'
    | '/_authenticated/settings'
    | '/_authenticated/stores'
    | '/_authenticated/weekly'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/weekly': {
      id: '/_authenticated/weekly'
      path: '/weekly'
      fullPath: '/weekly'
      preLoaderRoute: typeof AuthenticatedWeeklyRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/stores': {
      id: '/_authenticated/stores'
      path: '/stores'
      fullPath: '/stores'
      preLoaderRoute: typeof AuthenticatedStoresRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings': {
      id: '/_authenticated/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthenticatedSettingsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/performance': {
      id: '/_authenticated/performance'
      path: '/performance'
      fullPath: '/performance'
      preLoaderRoute: typeof AuthenticatedPerformanceRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/payroll': {
      id: '/_authenticated/payroll'
      path: '/payroll'
      fullPath: '/payroll'
      preLoaderRoute: typeof AuthenticatedPayrollRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/monthly': {
      id: '/_authenticated/monthly'
      path: '/monthly'
      fullPath: '/monthly'
      preLoaderRoute: typeof AuthenticatedMonthlyRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/exceptions': {
      id: '/_authenticated/exceptions'
      path: '/exceptions'
      fullPath: '/exceptions'
      preLoaderRoute: typeof AuthenticatedExceptionsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/employees': {
      id: '/_authenticated/employees'
      path: '/employees'
      fullPath: '/employees'
      preLoaderRoute: typeof AuthenticatedEmployeesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/dashboard': {
      id: '/_authenticated/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthenticatedDashboardRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/auto-reporting': {
      id: '/_authenticated/auto-reporting'
      path: '/auto-reporting'
      fullPath: '/auto-reporting'
      preLoaderRoute: typeof AuthenticatedAutoReportingRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
  }
}

interface AuthenticatedRouteChildren {
  AuthenticatedAutoReportingRoute: typeof AuthenticatedAutoReportingRoute
  AuthenticatedDashboardRoute: typeof AuthenticatedDashboardRoute
  AuthenticatedEmployeesRoute: typeof AuthenticatedEmployeesRoute
  AuthenticatedExceptionsRoute: typeof AuthenticatedExceptionsRoute
  AuthenticatedMonthlyRoute: typeof AuthenticatedMonthlyRoute
  AuthenticatedPayrollRoute: typeof AuthenticatedPayrollRoute
  AuthenticatedPerformanceRoute: typeof AuthenticatedPerformanceRoute
  AuthenticatedSettingsRoute: typeof AuthenticatedSettingsRoute
  AuthenticatedStoresRoute: typeof AuthenticatedStoresRoute
  AuthenticatedWeeklyRoute: typeof AuthenticatedWeeklyRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedAutoReportingRoute: AuthenticatedAutoReportingRoute,
  AuthenticatedDashboardRoute: AuthenticatedDashboardRoute,
  AuthenticatedEmployeesRoute: AuthenticatedEmployeesRoute,
  AuthenticatedExceptionsRoute: AuthenticatedExceptionsRoute,
  AuthenticatedMonthlyRoute: AuthenticatedMonthlyRoute,
  AuthenticatedPayrollRoute: AuthenticatedPayrollRoute,
  AuthenticatedPerformanceRoute: AuthenticatedPerformanceRoute,
  AuthenticatedSettingsRoute: AuthenticatedSettingsRoute,
  AuthenticatedStoresRoute: AuthenticatedStoresRoute,
  AuthenticatedWeeklyRoute: AuthenticatedWeeklyRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
